module.exports = __webpack_public_path__ + "img/01_Certificaciones_ISO_2015_2.2b6bad52.jpg";